export const appealsRegionsAdapter = (data: any) => {
  return data.map((item) => {
    const { name, propertyValues } = item
    const value = propertyValues.find(i => i.property.code === 'idRegion').value;
    return {
      name,
      value: +value,
    }
  })
}
